import React from 'react';

import View from './view';

const Component = ({ id }) => {
  return <View id={id} />;
};

export default Component;
